export default "__VITE_ASSET__BTnMAqhu__"